import { capitalize } from 'lodash'

import { isKubernetesStage } from './kubernetes'

import theme from 'theme'

const DOT_COLOR = {
  IN_FLIGHT: theme.colors.blue[0],
  SUCCESSFUL: theme.colors.green[0],
  HALTING: theme.colors.yellow[0],
  FAILED: theme.colors.red[0],
  UNSUCCESSFUL: theme.colors.steel[1]
}

const findStageType = status =>
  Object.keys(DOT_COLOR).find(key =>
    STAGES[key].some(colorState => colorState === status)
  )

export const STAGES = {
  NOT_STARTED: ['NotStarted', 'scheduled'],
  IN_FLIGHT: ['Distributed', 'Pending', 'Initializing', 'Running', 'Active'],
  SUCCESSFUL: ['Successful'],
  HALTING: [
    'Halt',
    'HaltDistributed',
    'RollbackTriggered',
    'InterruptTriggered',
    'HaltStarted',
    'RollbackStarted',
    'HaltRequested',
    'UserHalted'
  ],
  FAILED: [
    'Failed',
    'ClientAborted',
    'HaltFailed',
    'InitializationFailed',
    'ERROR'
  ],
  UNSUCCESSFUL: ['Aborted', 'TargetNotFound', 'LostCommunication']
}

//Active refers to things still moving, most relevent to polling.
export const ACTIVE_STAGES = [...STAGES.IN_FLIGHT, ...STAGES.HALTING]

export const FINISHED_STAGES = [
  ...STAGES.SUCCESSFUL,
  ...STAGES.FAILED,
  ...STAGES.UNSUCCESSFUL
]

// Note: in this case, "finished" means that the k8s attack data is resolved and will not update
// this indicates to us that we should not poll for updates after one of these stages is reached
// it is important to not that this does not necessarily mean that the attack is complete
//
// ERROR means that the attack encountered an error and is completed
//
// UserHalted means that the user halted the attack and it is completed
//            Yes, this casing is correct. The "USER_HALTED" stage is intentionally serialized like this on the backend.
//            see: https://github.com/gremlin/service/blob/staging/libraries/core/src/main/java/com/gremlininc/model/k8s/K8sAttack.java#L319
//
// LAUNCHED means that the k8s portion of the attack has resolved and the container attack was started
//          it DOES NOT mean that the attack has completed
export const KUBERNETES_RESOLVED_STAGES = ['LAUNCHED', 'ERROR', 'UserHalted']

// Stage
export const getAttackStageColor = stage => DOT_COLOR[findStageType(stage)]
export const isInCompleteStage = stage => FINISHED_STAGES.includes(stage)
export const isInActiveStage = stage => ACTIVE_STAGES.includes(stage)
export const isInFlightState = stage => STAGES.IN_FLIGHT.includes(stage)
export const isInNotStartedStage = stage => STAGES.NOT_STARTED.includes(stage)
export const isInHaltingStage = stage => STAGES.HALTING.includes(stage)
export const isInFailedStage = stage => STAGES.FAILED.includes(stage)
export const isInSuccessfulStage = stage => STAGES.SUCCESSFUL.includes(stage)

// Attack
export const isAttackInCompleteState = attack =>
  isInCompleteStage(attack?.stage)
export const isAttackInActiveState = attack => isInActiveStage(attack?.stage)
export const isKubernetesAttackInResolvedState = attack =>
  KUBERNETES_RESOLVED_STAGES.includes(attack?.stage)

export function getAttackStageReadable(stage = '', error) {
  const formattedStage = isKubernetesStage(stage)
    ? capitalize(stage)
    : stage.replace(/([A-Z])/g, ' $1').trim()

  return `${formattedStage}${error || ''}`
}
